import React, { useEffect, useState } from 'react';
import { getUuid, getSignupType } from './utils';
import { useFetchSignupActivation } from './hooks';
import LoadingPageBody from '../components/foundations/LoadingPageBody';

const LoadingPage = () => {
    const [warningMsg, setWarningMsg] = useState('');

    const uuid = getUuid();
    const signupType = getSignupType();
    const { error, isLoading, ...resp } = useFetchSignupActivation(uuid, signupType);

    useEffect(() => {
        if (!isLoading) {
            resp.url ? (window.location.href = resp.url) : setWarningMsg(resp.message);
        }
    }, [isLoading]);

    return <LoadingPageBody warningMsg={warningMsg} />;
};

export default LoadingPage;
